import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { ITenderTranInputModel, ITenderTranListInputModel, WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { CommonService } from '../Common.service';
import { MapRoleFeatureService } from '../map-role-feature/map-role-feature.service';
import { RestApiService } from '../rest-api.service';
import { RespondWorkflowListModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { IDCINoOfSheetsModel, IWFDocCategoryModel } from 'src/app/ViewModel/WorkflowActionModel';
import { IWorkflowStatusInputModel } from 'src/app/ViewModel/WorkflowStatusModel';
import { WorkflowTemplateDataService } from 'src/app/Service/workflow-template/workflow-template-data.service'
import { map } from 'rxjs/operators';
@Injectable({
	providedIn: 'root'
})
export class WorkflowTemplateService {
	private readonly getWorkflowListUrl = 'WorkflowTemplate/GetWorkflowTemplateList';
	private readonly getWorkflowTemplateUrl = 'WorkflowTemplate/GetWorkflowTemplate';
	private readonly postWorkflowTemplateUrl = 'WorkflowTemplate/PostWorkflowTemplate';
	private readonly deleteWorkflowTemplateUrl = 'WorkflowTemplate/DeleteWorkFlowTemplate';
	private readonly getRespondWorkflowList = 'WorkflowTransaction/GetRespondWorkflowList';
	private readonly getWorkflowDocumentCheckistUrl = "WorkflowTransaction/GetWorkflowDocumentCheckist";
	private readonly getChecklistworkflowItemUrl = "WorkflowTransaction/GetWorkflowDocumentCheckistItem";
	private readonly postChecklistworkflowItemUrl = 'WorkflowTransaction/PostWorkflowDocumentCheckist';
	private readonly PostWorkflowDocumentCopyCheckistItemUrl = 'WorkflowTransaction/PostWorkflowDocumentCopyCheckist';
	private readonly dedAgainstDEGetUrl = "DEDED/GetCommonDEDAgainstDE";
	private readonly respondWorkflowDetails = "WorkflowTransaction/PostRespondWorkflowDetails";
	private readonly holdWorkflowDoc = "WorkflowTransaction/HoldRespondWorkflowDocument";
	private readonly getWorkflowMemberByRoleUrl = "WorkflowTransaction/GetWorkflowMemberByRole";
	private readonly updateWFAssignedToRoleUserUrl = "WorkflowTransaction/UpdateWorkflowStepAssignedTo";
	private readonly sendMailOnActionCompletion = "WorkflowTransaction/SendMailOnActionCompletion";
	private readonly BulksendMailOnActionCompletion = "WorkflowTransaction/BulkSendMailOnActionCompletion";
	private readonly insertUpdateTenderTransactionUrl = "WorkflowTransaction/InsertUpdateTenderTransaction";
	private readonly getTenderTranWorkflowDetailsUrl = "WorkflowTransaction/GetTenderTranWorkflowDetails"
	private readonly deleteWorkflowDocumentCheckistUrl = 'WorkflowTransaction/DeleteWorkflowDocumentCheckist';
	private readonly updateWorkflowDocumentCategoryUrl = 'WorkflowTransaction/UpdateWorkflowDocumentCategory';
	private readonly updateDCINoOfSheetsUrl = 'WorkflowTransaction/UpdateDCINoOfSheets';
	private readonly getWorkflowStatus = 'WorkflowTransaction/GetWorkflowStatusList';
	private readonly get_Checklist = 'WorkflowTransaction/GetWorkflowDocumentRevisionCheckist';
	private readonly getCCNDetails = 'CCN/GetCCNListByDocId';
	private readonly GetWorkflowCategory = 'WorkflowTransaction/GetWorkflowCategoryActionMap';
	private readonly GetWorkflowLatestStageDetails = 'WorkflowTemplate/GetWorkflowLatestStageDetails';
	private readonly bulkrespondWorkflowDetails = "WorkflowTransaction/BulkPostRespondWorkflowDetails";
	private readonly GetWorkflowTemplateDetails = "WorkflowTemplate/GetWorkflowTemplateDetails";
	private readonly updateWFAssignedToRoleUserUrlBulkUrl = "WorkflowTransaction/UpdateWorkflowStepAssignedToBulk"

	public supportForBottomKendo: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	public supportForClearInputData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public supportForClearMainData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public supportForClearSelectedWfStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public customTaskId: number | undefined;
	public isViewMode: boolean = false;
	public isCreateMode: boolean = false;
	public isEditMode: boolean = false;
	public isCopyMode: boolean = false;
	public selectedTaskId: number | null = null;

	constructor(
		private commonService: CommonService,
		private mapRoleFeatureService: MapRoleFeatureService,
		private restApiService: RestApiService,
		private WorkflowTemplateDataService: WorkflowTemplateDataService) { }

	getWorkflowTemplateList(icId: null | number, buId: null | number, projectId: null | number, groupId: null | number, workflowId: null | number): Observable<WorkflowTemplateModel[]> {
		let reqData = {
			projectId,
			icId,
			buId,
			groupId,
			workflowId
		}
		return this.restApiService.new_POST(this.getWorkflowListUrl, reqData);
	}

	getWorkflowTemplate(workflowId: number) {
		let reqData = {
			workflowId,
			"isActive": true
		};
		return this.restApiService.new_POST(this.getWorkflowTemplateUrl, reqData);
	}

	postWorkflowTemplate(reqData: WorkflowTemplateDialogModel) {
		return this.restApiService.new_POST(this.postWorkflowTemplateUrl, reqData);
	}

	getChecklist(reqData: any) {
		return this.restApiService.new_POST(this.get_Checklist, reqData);
	}

	deleteWorkflowTemplate(workFlowId: number) {
		return this.restApiService.new_POST(this.deleteWorkflowTemplateUrl, { "workflowId": workFlowId, "isActive": false });
	}

	getWorkflowTaskList(groupId: null | number, moduleId: number, moduleDescription: string, deId: null | number, deDescription: string, dependentDEId: null | number, dependentDEDId: null | number, ProjectId: number | null): Observable<RoleFeatureModel[]> {
		return this.mapRoleFeatureService.getDedAgainstDe(deDescription, groupId, moduleId, dependentDEDId, dependentDEDId, ProjectId);
	}

	/**
	 * Change data to respective cart selected data format
	 * @param value 
	 * @param text 
	 */
	getAsCartSelectedValue(value: string | number, text: string) {
		value = value.toString().trim();
		text = text.trim();
		let output = {
			value,
			text: value + ' - ' + text
		};
		return output;
	}

	getWorkflowCategory(obj: any) {
		return this.restApiService.new_POST(this.GetWorkflowCategory, obj);
	}

	getRespondWorkflowDetails(projectId: number, groupId: number, memberId: number, lastViewingRecords: null | number, documentStatus?: number, isDeligatedDocuments: boolean = false, isAllworkflow: boolean = false, docId: number = null, revision_no: string = null): Observable<RespondWorkflowListModel[]> {
		let requiredData = {
			projectId,
			groupId,
			memberId,
			documentStatus,
			isDeligatedDocuments,
			lastViewingRecords,
			isAllworkflow,
			docId,
			revision_no
		};
		return this.restApiService.new_POST(this.getRespondWorkflowList, requiredData);
	}

	getCommonDEDAgainstDE(description: any) {
		let reqData = { "DEDescription": description };
		return this.restApiService.new_POST(this.dedAgainstDEGetUrl, reqData);
	}

	getWorkflowDocumentCheckist(documentId: number, documentRevision: string, workflowId: number) {
		let redData: any = {
			"documentId": documentId,
			"documentRevision": documentRevision,
			"workflowId": workflowId
		}
		return this.restApiService.new_POST(this.getWorkflowDocumentCheckistUrl, redData);
	}

	getWorkflowChecklistItem(getWorkflowItem: any) {
		let redData: any = {
			"documentId": getWorkflowItem.documentId,
			"documentRevision": getWorkflowItem.documentRevisionNo,
			"clId": getWorkflowItem.clId,
			"clRevision": getWorkflowItem.clRevisionNo
		}
		return this.restApiService.new_POST(this.getChecklistworkflowItemUrl, redData);
	}

	postWorkflowChecklistItem(newWorkflowItem: any, isForApproval: boolean) {
		let reqData = {
			'projectId': this.commonService.getProjectId(),
			'groupId': this.commonService.getLoggedInUserGroupId(),
			'checklistDetails': newWorkflowItem,
			'createdBy': this.commonService.getLoggedInUserId(),
			'approvedBy': isForApproval ? this.commonService.getLoggedInUserId() : null
		}
		return this.restApiService.new_POST(this.postChecklistworkflowItemUrl, reqData);
	}

	PostWorkflowDocumentCopyCheckist(newWorkflowItem: any) {
		let reqData = {
			'checklistDetails': newWorkflowItem
		}
		return this.restApiService.new_POST(this.PostWorkflowDocumentCopyCheckistItemUrl, reqData);
	}
	postRespondWorkflowDetails(getValue: any) {
		return this.restApiService.new_POST(this.respondWorkflowDetails, getValue);
	}
	holdWorkflow(holdDoc: any) {
		return this.restApiService.new_POST(this.holdWorkflowDoc, holdDoc);
	}
	BulkPostRespondWorkflowDetails(getValue: any) {
		return this.restApiService.new_POST(this.bulkrespondWorkflowDetails, getValue);
	}
	getWorkflowMemberByRole(reqData: any) {
		return this.restApiService.new_POST(this.getWorkflowMemberByRoleUrl, reqData);
	}

	updateWFAssignedToRoleUser(reqData: any) {
		return this.restApiService.new_POST(this.updateWFAssignedToRoleUserUrl, reqData);
	}

	updateWFAssignedToRoleUserBulk(reqData: any) {
		return this.restApiService.new_POST(this.updateWFAssignedToRoleUserUrlBulkUrl, reqData);
	}

	SendMailOnActionCompletion(reqData: any) {
		return this.restApiService.new_POST(this.sendMailOnActionCompletion, reqData);
	}

	BulkSendMailOnActionCompletion(reqData: any) {
		return this.restApiService.new_POST(this.BulksendMailOnActionCompletion, reqData);
	}

	insertUpdateTenderTransaction(reqData: ITenderTranInputModel) {
		return this.restApiService.new_POST(this.insertUpdateTenderTransactionUrl, reqData);
	}

	getTenderTranWorkflowDetails(reqData: ITenderTranListInputModel) {
		return this.restApiService.new_POST(this.getTenderTranWorkflowDetailsUrl, reqData);
	}

	deleteWorkflowDocumentCheckist(docId: any, revisionNo: any, clId: any, clRevisionNo: any, memberId: number) {
		let reqData = {
			'documentId': docId,
			'documentRevision': revisionNo,
			'clId': clId,
			'cLRevision': clRevisionNo,
			'createdBy': memberId
		}
		return this.restApiService.new_POST(this.deleteWorkflowDocumentCheckistUrl, reqData);
	}

	GetWorkflowLatestStageDetail(reqData: any) {
		let input = {
			'Doc_Id': reqData.Doc_Id,
			'Stage_Ids': reqData.Stage_Ids
		}
		return this.restApiService.new_POST(this.GetWorkflowLatestStageDetails, input);
	}

	UpdateWorkflowDocumentCategory(reqData: IWFDocCategoryModel) {
		return this.restApiService.new_POST(this.updateWorkflowDocumentCategoryUrl, reqData);
	}

	UpdateDCINoOfSheets(reqData: IDCINoOfSheetsModel) {
		return this.restApiService.new_POST(this.updateDCINoOfSheetsUrl, reqData);
	}

	GetWorkflowStatusDetails(reqData: IWorkflowStatusInputModel) {
		return this.restApiService.new_POST(this.getWorkflowStatus, reqData);
	}

	GetWorkflowStatusCCNDetails(doc_Id: any) {
		let reqData = { 'doc_Id': doc_Id, };
		return this.restApiService.new_POST(this.getCCNDetails, reqData);
	}

	getWorkflowTemplateDetails(workflowIds: string) {
		let reqData = {
			workflowIds,
			"isActive": true
		};
		return this.restApiService.new_POST(this.GetWorkflowTemplateDetails, reqData);
	}
}
